import {
  InfiniteData,
  useInfiniteQuery,
  UseInfiniteQueryResult
} from "@tanstack/react-query";

import {
  ConversationsPage,
  GetConversationsParams
} from "@/types/conversations";

import { getConversations } from "./conversationsApi";

export const CONVERSATIONS_QUERY_KEY = "conversations";

export const useGetInfiniteConversations = (
  params: GetConversationsParams = {},
  options: { enabled?: boolean } = {}
): UseInfiniteQueryResult<InfiniteData<ConversationsPage>, Error> =>
  useInfiniteQuery<
    ConversationsPage,
    Error,
    InfiniteData<ConversationsPage>,
    unknown[],
    string | undefined
  >({
    queryKey: [CONVERSATIONS_QUERY_KEY, params.q?.trim() ?? ""],
    queryFn: ({ pageParam }) => getConversations(params, pageParam),
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    retry: 1,
    ...options
  });
